import React from 'react';
import { letter } from '../../DocumentPaperLetter';

const ContainerTables = ({ children, isIndividual = false }) => {
  return (
    <div
      className={
        isIndividual ? 'd-flex flex-column justify-content-center' : ''
      }
      style={
        isIndividual ? { height: `${letter.HEIGHT / 2}cm`, gap: '1rem' } : {}
      }
    >
      {children}
    </div>
  );
};

export default ContainerTables;
